import { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import apiConfig from "@Configs/api/api.config"
import { Api } from "@Configs/api/api";
import { API_UPLOAD_IMAGE } from "./endpoint"
import { ENTERPRISE_ID } from "@Constants/localStorage";



class BaseApi extends Api {
  public constructor(config: AxiosRequestConfig) {
    super(config);
    this.uploadImage = this.uploadImage.bind(this);
  }

  public uploadImage(formData: any): Promise<number> {
    const businessID = localStorage.getItem(ENTERPRISE_ID) || localStorage.getItem("ENTERPRISE_ID") || "";
    if (formData?.get && formData?.append && !formData.get("files") && formData.get("photo")) {
      formData.append("files", formData.get("photo"));
      formData.delete("photo");
    }
    if (formData?.get && formData?.append && !formData.get("businessID")) {
      if (businessID) formData.append("businessID", businessID);
    }
    return this.post<any>(API_UPLOAD_IMAGE, formData, {
      headers: {
        "x-business-id": businessID,
      },
    })
      .then((response: AxiosResponse<any>) => {
        const { data } = response;
        return data;
      })
      .catch((error: AxiosError) => {
        throw error;
      });
  }


}
const baseApi = new BaseApi(apiConfig);

export default baseApi;
